import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SessionState } from "types/store.types";

const initialState: SessionState = {
  token: "",
  imageUrl: "",
  signedIn: false,
};

export const sessionSlice = createSlice({
  name: "auth/session",
  initialState,
  reducers: {
    onSignInSuccess: (state, action: PayloadAction<{ data: { token: string } }>) => {
      state.signedIn = true;
      state.token = action.payload?.data?.token;
    },
    onSignOutSuccess: (state) => {
      state.signedIn = false;
      state.token = "";
      state.imageUrl = "";
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
  },
});

export const { onSignInSuccess, onSignOutSuccess, setToken } =
  sessionSlice.actions;
export default sessionSlice.reducer;
